import { useState } from 'react'
import { useGetTransferSettings, useSetTransferSettings } from '../../../../core/services/react-query/report/transfer'
import { DText, Flex } from '../../../../styles/CommonStyles';
import { SOCKET_URL } from '../../../../core/constants/urls';
import styled from 'styled-components';
import Text from '../../../../core/utils/Text';
import { FaTrash } from 'react-icons/fa';
import ModalLayout from '../../../layout/main/ModalLayout';
import BasicModal from '../../../modals/BasicModal';
import { CircleLoader, ScaleLoader } from 'react-spinners';
import { useSetSwapSettings } from '../../../../core/services/react-query/setting/swap';

const SwapSettingsList = ({ swapSettings }) => {

    const [deleteModal, setDeleteModal] = useState({ currencyId: null, open: false })
    const onCloseDeleteModal = () => setDeleteModal({ currencyId: null, open: false })

    const { mutate: mutateSetConfig, isLoading: loadingSetConfig } = useSetSwapSettings(onCloseDeleteModal)

    const onDeleteCoin = () => {
        const newCurrencies = swapSettings?.currencies.filter(item => item.currency !== deleteModal.currencyId)
        mutateSetConfig({
            thirdParty: swapSettings.thirdParty,
            currencies: newCurrencies
        })
    }

    return (
        <div className='grid grid-cols-1  sm:grid-cols-2 lg:grid-cols-4 gap-5 border-t py-5'>
            <div className='col-span-1 sm:col-span-2 lg:col-span-4'>
                <DText main>
                    <Text tid="swap-list" />
                </DText>
            </div>
            <>
                {swapSettings?.currencies?.map((item, idx) => {

                    return (
                        <Wrapper
                        >
                            <Flex fw fh justify={'flex-start'} style={{ gap: 10 }}>
                                <DText main>{idx + 1}-</DText>
                                <img
                                    src={item.currency === 'irt' ? require("../../../../assets/images/tooman.png") :
                                        SOCKET_URL + `assets/icon/${item.currency}.png`}
                                    alt={' '}
                                    width={'28px'}
                                />
                                <DText main>
                                    {item.currency}
                                </DText>
                                <button onClick={() => { setDeleteModal({ currencyId: item.currency, open: true }) }} className='mr-auto hover:opacity-70'>
                                    <FaTrash color='#c33' />
                                </button>
                            </Flex>
                        </Wrapper>
                    )
                })}
            </>
            <ModalLayout open={deleteModal.open} onClose={onCloseDeleteModal} width={"500px"}>
                <BasicModal onClose={onCloseDeleteModal} onSubmit={onDeleteCoin} loading={loadingSetConfig} />
            </ModalLayout>
        </div>
    )
}
const Wrapper = styled.div`
  border-radius: 8px;
  background-color: ${props => props.theme.secondaryBg};
  padding: 8px 16px;
`
export default SwapSettingsList